import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { type DashboardFilters } from "./useLiveDashboardFilters";

export const useLiveOrdersHourly = (filters: DashboardFilters) =>
  useQuery({
    queryKey: ["live_orders_by_hour", filters],
    queryFn: async () => await apiClient.getLiveOrdersHourlyData({ queries: filters }),
  });
